import React from "react";
import "../projects.css";
import Timeline from "../timeline/armoireTimeline";
import "bootstrap/dist/css/bootstrap.min.css";

function Armoire() {
  return (
    <div className="project-container">
      <div className="banner">
        <img
          src="assets/projects/armoire/armoire-banner.png"
          alt="Armoire Project"
          className="banner-image"
        />
      </div>

      {/* Project Header */}
      <div className="project-header">
        <h1 className="project-title">Armoire</h1>
        <p className="project-subtitle">
          A self-directed project exploring how to translate a physical closet into a digital wardrobe. The goal was to create a simple, natural experience that mirrors how people actually browse their closet.
        </p>
        <div className="badge-container">
          <span className="badge">UI/UX Design</span>
          <span className="badge">Prototyping</span>
          <span className="badge">Interaction Design</span>
          <span className="badge">Figma</span>
        </div>
      </div>

      {/* Overview Section - 3 Columns */}
      <div className="project-overview">
        <div className="overview-3col">
          <div className="overview-col-item">
            <div className="overview-icon">🧭</div>
            <h3 className="overview-title">My Role</h3>
            <p className="overview-text">
              Solo designer for this self-study project. I defined the interaction model, designed all user flows, and built the complete prototype independently.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">⏱️</div>
            <h3 className="overview-title">Timeline</h3>
            <p className="overview-text">
              Two-week sprint focused on translating how people interact with their physical closet into a clean, intuitive mobile experience.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">✨</div>
            <h3 className="overview-title">Focus Areas</h3>
            <ul className="overview-list">
              <li>Natural mapping from physical closet to UI</li>
              <li>Curated prompts for quick outfit selection</li>
              <li>Minimalist, visual-first browsing inspired by Pinterest</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Design Challenge Section */}
      <div className="case-study-section">
        <h2 className="section-title">Design Challenge</h2>
        <div className="case-study-content">
          <p className="case-study-text">
            Armoire helps people organize closets and plan outfits without the clutter of traditional e-commerce. The goal was to mirror the ease of skimming a real closet while adding light guidance for “what should I wear?” moments.
          </p>
          <p className="case-study-text">
            I anchored the layout on Pinterest patterns to keep the interface simple and visual-centric. Translating hangers, shelves, and “quick grabs” into cards and boards preserved natural mapping and reduced cognitive load.
          </p>
          <div className="brand-values">
            <h3 className="brand-values-title">What I Explored</h3>
            <div className="values-grid">
              <div className="value-item">
                <span className="value-icon">🧩</span>
                <div className="value-content">
                  <strong>Conceptual Model</strong>
                  <span className="value-text">Designed navigation that mirrors how people physically scan their closet.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">🎯</span>
                <div className="value-content">
                  <strong>Prompted Choices</strong>
                  <span className="value-text">Created quick prompts to reduce decision fatigue when choosing outfits.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">🧹</span>
                <div className="value-content">
                  <strong>Minimal Surface</strong>
                  <span className="value-text">Maintained a simple, visual-first interface that keeps focus on the outfits.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="content-section">
        <Timeline />
      </div>
    </div>
  );
}

export default Armoire;
